import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FormData from "form-data";
import "react-toastify/dist/ReactToastify.css";
import { getProductRate } from "../../redux/actions/action-creator";
import ReviewPopupFrame from "./ReviewPopupFrame";

import './ReviewPopup.css';

const RATING_LABELS = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];
const ReviewPopup = ({
  show,
  onClose,
  onSubmitSuccess,
  order_id = "R48963160",
  productName = "Green Fresh Drumstick",
  order_no,
  user_rating,
  productImage = null,
  productPrice = null,
  productUnit = null,
  product_variant_id = null,
}) => {
  const dispatch = useDispatch();
  console.log("user_rating", user_rating)
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [review, setReview] = useState('');
  const [image_one, setImages] = useState([]);
  const maxWords = 200;
  useEffect(() => {
    if (user_rating) {
      setRating(Number(user_rating));
      setHover(Number(user_rating));
    }
  }, [user_rating, show]);

  const wordCount = review.trim()
    .split(/\s+/)
    .filter(w => w.length > 0).length;

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map(file => URL.createObjectURL(file));
    setImages(prev => [...prev, ...newImages]);
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (rating === 0) {
      alert('Please select a rating.');
      return;
    }
    const payload = { order_id, product_variant_id, productName, rating, review, image_one };
    console.log('Review submitted:', payload);
    let formData = new FormData();

    formData.append("order_id", order_id);
    formData.append("product_variant_id", product_variant_id);
    formData.append("rating", rating);
    formData.append("review", review);

    // Images array - har image alag append hogi
    image_one.forEach((imgFile, index) => {
      formData.append(`image_one`, imgFile);
    });

    console.log('Review submitted payload:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }
  
    const response = await dispatch(getProductRate(formData));
    if (response?.result) {

      // ✅ Parent ko data bhejo
      onSubmitSuccess && onSubmitSuccess({
        order_id,
        product_variant_id,
        rating,
        review,
        response
      });
    }
    // TODO: API call here
     handleClose();
  };

  const handleClose = () => {
    setRating(0);
    setHover(0);
    setReview('');
    setImages([]);
    onClose();
  };

  if (!show) return null;

  const activeRating = hover || rating;

  return (
    <>
      <ReviewPopupFrame title="Write a Review" onClose={handleClose}>
          {/* Body */}
          <div className="review-popup-body">

            {/* Order ID */}
            <p className="review-order-id">Order ID: #{order_no}</p>

            {/* Product Info */}
            <div className="review-product">
              <div className="review-product-image">
                {productImage
                  ? <img src={productImage} alt={productName} />
                  : <span>🥒</span>
                }
              </div>
              <div className="review-product-details">
                <span className="review-product-name">{productName}</span>
                {(productPrice || productUnit) && (
                  <span className="review-product-meta">
                    {productPrice && `₹ ${productPrice}`}
                    {productPrice && productUnit && ' · '}
                    {productUnit}
                  </span>
                )}
              </div>
            </div>

            {/* Star Rating */}
            <div className="review-rating-group">
              <label className="review-label">Your Rating</label>
              <div className="review-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`review-star ${star <= activeRating ? 'active-start' : ''}`}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(0)}
                  >
                    ★
                  </span>
                ))}
              </div>
              <span className="review-rating-label">
                {activeRating > 0 ? RATING_LABELS[activeRating] : ''}
              </span>
            </div>

            {/* Review Textarea */}
            <div className="review-input-group">
              <label className="review-label">Write your review</label>
              <textarea
                value={review}
                onChange={(e) => setReview(e.target.value)}
                placeholder="Share your experience with this product..."
                className="review-textarea"
                rows="3"
              />
              <div className="review-word-count">
                <span className={wordCount > maxWords ? 'review-word-count-over' : ''}>
                  ~{Math.min(wordCount, maxWords)} / {maxWords} words
                </span>
              </div>
            </div>

            {/* Image Upload */}
            <div className="review-upload-section">
              <label className="review-label">Upload Images (Optional)</label>
              <div className="review-images-grid">
                {image_one.map((img, index) => (
                  <div key={index} className="review-image-item">
                    <img src={img} alt={`Upload ${index + 1}`} />
                    <button
                      type="button"
                      onClick={() => removeImage(index)}
                      className="review-image-remove"
                    >×</button>
                  </div>
                ))}
                <label className="review-upload-box">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                </label>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="review-popup-footer">
            <button className="review-btn review-btn-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button
              className="review-btn review-btn-submit"
              onClick={handleSubmit}
              disabled={rating === 0}
            >
              Submit Review
            </button>
          </div>

      </ReviewPopupFrame>
    </>
  );
};

export default ReviewPopup;
